import { psCollection } from "./powersync-collection.js";
import {
  tableSchema,
  reservationSchema,
  tableSessionSchema,
  type Table,
  type Reservation,
  type TableSession,
} from "../schemas/floor.js";

export const tablesCollection = psCollection("tables", tableSchema);

export const reservationsCollection = psCollection("reservations", reservationSchema);

export const tableSessionsCollection = psCollection("table_sessions", tableSessionSchema);
